import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import FloatingWhatsApp from '@/components/feature/FloatingWhatsApp';
import Breadcrumb from '@/components/base/Breadcrumb';
import HeroSection from './components/HeroSection';
import DifferentiatorsSection from './components/DifferentiatorsSection';
import ServicesSection from './components/ServicesSection';
import AboutSection from './components/AboutSection';
import PatientJourneySection from './components/PatientJourneySection';
import TestimonialsSection from './components/TestimonialsSection';
import GallerySection from './components/GallerySection';
import FAQSection from './components/FAQSection';
import MapSection from './components/MapSection';
import CTASection from './components/CTASection';
import BlogSection from './components/BlogSection';

export default function Home() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-24">
        <Breadcrumb items={[
          { label: 'Início', href: '/' },
          { label: 'Consultório Odontológico Premium na Faria Lima' },
        ]} />
      </div>
      <TestimonialsSection />
      <DifferentiatorsSection />
      <ServicesSection />
      <AboutSection />
      <PatientJourneySection />
      <GallerySection />
      <FAQSection />
      <MapSection />
      <BlogSection />
      <CTASection />
      <Footer />
      <FloatingWhatsApp />
    </main>
  );
}